import {ContainerGrow} from "./Documentation.css";
import {OrphanLink} from "../../global.css";
import React from "react";

const Fallback = () => {
    return (
        <div className={ContainerGrow}>
            <p>La mise en place d'une stratégie d’urgence (ou fallback) vise à couvrir un éventuel temps d’arrêt de l’API.</p>
            <p>Elle offre aux prestataires de service, possédant un certificat eIDAS QWAC, un accès à la banque en ligne afin de répondre aux exigences réglementaires de la
                DSP2.</p>
            <p>Les fonctionnalités PISP ne sont pas disponibles en mode fallback.</p>
            <br/>
            <p>Fallback URL : <span className={OrphanLink}>(NO LINK)</span></p>
        </div>
    )
}

export default Fallback;